import React from "react";
// import React, { useEffect, useState } from "react";
// import Preloader from "../components/Loader";

// Home Components
import HomeSlider from "../components/Home/HomeSlider";
import ServiceCard from "../components/Common/ServiceCard";
import SectionTitle from "../components/Common/SectionTitle";
import ExpertCard from "../components/Common/ExpertCard";
import Highlighted from "../components/Common/Highlighted";
import FaqSection from "../components/Common/Faq";
import { CCol, CContainer, CRow } from "@coreui/react";

// import BrandOneLogo from "../assests/ndis1.jpg";
import BrandTwoLogo from "../assests/ndis2.jpg";

// import HomeTestimonials from "../components/Home/HomeTestimonials";

// import flag from "../assests/flag.jpg";
import staticData from "../assests/staticData.json";

export default function Home() {
  // const [loading, setLoading] = useState(true);
  const { services_list, home_aboutus } = staticData;
  // useEffect(() => {
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 1000);
  // }, []);

  return (
    <>
      {/* {loading && <Preloader />} */}
      <section className="homeslider-main-wrapper position-relative">
        <HomeSlider></HomeSlider>
      </section>
      <section className="home-blog-images-wrapper pt-3 pb-3">
        <CContainer>
          <CRow className="justify-content-center align-items-center gx-lg-5">
            {/* <CCol lg={3} xs={4}>
              <div className="home-brand-img">
                <img
                  src={BrandOneLogo}
                  alt="brand-logo"
                  className="img-fluid"
                />
              </div>
            </CCol> */}
            <CCol lg={3} xs={8}>
              <div className="home-brand-img logo-brand-two text-center">
                <img
                  src={BrandTwoLogo}
                  alt="brand-logo"
                  className="img-fluid"
                  style={{ width: "220px", height: "90px" }}
                />
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </section>

      {/* Service Cards */}
      <section className="service-section-wrapper mobile-version">
        <CContainer>
          <CRow>
            <CCol lg={12}>
              <div className="mt-lg-5 mb-lg-5 mt-0 mb-0">
                <SectionTitle
                  align={"center"}
                  subTitle={"services"}
                  subtitle={true}
                  Title={"what we provide"}
                  desc={""}
                />
              </div>
            </CCol>
          </CRow>
          <CRow className="justify-content-center">
            {services_list.length > 0 &&
              services_list
                .filter((service) => service.title !== "Plan Management")
                .map((service) => (
                  <CCol lg={4} key={service.id} className="mb-3">
                    <ServiceCard service={service} />
                  </CCol>
                ))}
          </CRow>
        </CContainer>
      </section>

      {/* Expertises */}

      <section className="expertises-section-wrapper">
        <CContainer>
          <CRow>
            <CCol lg={12}>
              <div>
                <SectionTitle
                  align={"center"}
                  subTitle={"Expertises"}
                  subtitle={true}
                  Title={"How it works"}
                  desc={
                    "We know all about your worries you’re facing when it comes to choosing a carer  for you or loved one- but don’t worry, we will be on your side every step of way"
                  }
                />
              </div>
            </CCol>
          </CRow>
          <CRow className="gx-0 mt-4 expertCards-radius">
            <ExpertCard />
          </CRow>
        </CContainer>
      </section>

      {/* Testimonials */}
      {/* <section className="testimonials-section-wrapper">
        <CContainer>
          <CRow className="mb-5">
            <CCol lg={12}>
              <div>
                <SectionTitle
                  align={"center"}
                  subTitle={"testimonials"}
                  subtitle={true}
                  style2={true}
                  Title={"people say about us"}
                />
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol lg={12}>
              <div>
                <HomeTestimonials />
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </section> */}

      {/* About Us */}
      <section className="home-aboutus-section-wrapper">
        <CContainer>
          <div className="home-aboutus-placeholder">
            <CRow>
              <CCol lg={12}>
                <div className="home-aboutus-wrapper">
                  <div className="home-aboutus-header">
                    <CRow className="gx-0">
                      <CCol lg={3}>
                        <div className="header-tabs-wrapper yellow-tab">
                          <h5 className="mb-0">Disability Care</h5>
                        </div>
                      </CCol>
                      <CCol lg={3}>
                        <div className="header-tabs-wrapper theme-tab">
                          <h5 className="mb-0">Home Care</h5>
                        </div>
                      </CCol>
                      <CCol lg={3}>
                        <div className="header-tabs-wrapper yellow-tab">
                          <h5 className="mb-0">Therapeutic Support</h5>
                        </div>
                      </CCol>
                      <CCol lg={3}>
                        <div className="header-tabs-wrapper theme-tab">
                          <h5 className="mb-0">Community Care</h5>
                        </div>
                      </CCol>
                    </CRow>
                  </div>
                </div>
              </CCol>
            </CRow>
            <CRow className="justify-content-center">
              <CCol lg={11}>
                <div className="mt-5 mb-4">
                  <SectionTitle
                    align={"center"}
                    subTitle={"About us"}
                    subtitle={true}
                    Title={
                      "Empowering people. Enhancing independence. Enriching lives."
                    }
                  />
                </div>
                <div className="text-center">
                  {home_aboutus.length > 0 &&
                    home_aboutus.map((desc, index) => (
                      <p className="themeGrayPara in-fs lh-28" key={index}>
                        {desc}
                      </p>
                    ))}
                </div>
              </CCol>
            </CRow>
            <CRow className="justify-content-center mb-5 mt-4">
              <CCol lg={5}>
                <Highlighted />
              </CCol>
            </CRow>
          </div>
        </CContainer>
      </section>

      {/* Faq */}
      <section className="faq-section-wrapper">
        <CContainer>
          <CRow className="justify-content-center mb-5">
            <CCol lg={6}>
              <SectionTitle
                subtitle={true}
                align={"center"}
                subTitle={"faq"}
                Title={"some questions"}
              />
            </CCol>
          </CRow>
          <CRow className="justify-content-center">
            <CCol lg={7}>
              <FaqSection />
            </CCol>
          </CRow>
        </CContainer>
      </section>

      {/* Home CTA */}
      <section className="home-cta pb-0">
        <CContainer>
          <CRow className="justify-content-center">
            <CCol lg={11}>
              <div className="text-center">
                <p className="themeGrayPara in-fs lh-28">
                  With great dedication, we at Wattle Care strive to deliver
                  considerate and dependable services that makes it possible for
                  people to live their life as they desire. Through
                  individualized support, compassionate care, and understanding,
                  our services enable independence, personal development, social
                  inclusion, and holistic wellbeing.
                </p>
                {/* <img src={flag} alt="flag" className="mt-3" /> */}
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </section>

      {/* ABN Number */}
      <section className="abn-number-wrapper pt-3 mb-3">
        <CContainer>
          <CRow className="justify-content-center">
            <CCol lg={11}>
                <div className="text-center">
                  <strong style={{fontSize:"40px",color:"#0b3d2c"}}>ABN</strong>
                  <p style={{fontSize:"40px",color:"#0b3d2c", lineHeight:"40px", fontWeight:"600"}} className="mt-0">11 640 035 463</p>
                </div>
            </CCol>
          </CRow>
        </CContainer>
      </section>
    </>
  );
}
